import { OrganizationTraits, ProjectPrivacy } from '@neptune/shared/core-organizations-domain';
import { isProjectPrivacyAvailable } from '@neptune/shared/core-project-business-logic';

export const shouldShowProjectRoleTooltip = (
  organizationTraits: OrganizationTraits,
  privacy: ProjectPrivacy,
): boolean => {
  return (
    privacy === ProjectPrivacy.workspace &&
    !isProjectPrivacyAvailable(ProjectPrivacy.private, organizationTraits)
  );
};

export const shouldShowProjectAccessTooltip = (organizationTraits: OrganizationTraits): boolean => {
  return !isProjectPrivacyAvailable(ProjectPrivacy.private, organizationTraits);
};
